import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';

/** 排序方式 UI 态（const + as const，替代 enum） */
export const SortByEnum = {
  Default: 'default',
  Metric: 'metric',
  Manual: 'manual',
  /** 按数据表字段排序（仅 X/Y 轴排序；图例系列排序须 hidden） */
  DatasetFieldSort: 'datasetFieldSort',
} as const;

export type TSortByEnum = (typeof SortByEnum)[keyof typeof SortByEnum];

export interface ISortTypeProps {
  value: string;
  onChange: (value: string) => void;
  /** 需要隐藏的选项（如图表类型不支持手动排序） */
  hiddenOptions?: TSortByEnum[];
  className?: string;
}

/** 选择排序方式的组件 */
const SortType: React.FC<ISortTypeProps> = props => {
  const { formatMessage } = useIntl();
  const { value, onChange, hiddenOptions, ...rest } = props;

  const options = useMemo(() => {
    const allOptions = [
      {
        value: SortByEnum.Default,
        text: formatMessage({ id: 'dbl_chart_default_sorting' }),
      },
      {
        value: SortByEnum.Metric,
        text: formatMessage({ id: 'dbl_chart_custom_metric_sort' }),
      },
      {
        value: SortByEnum.Manual,
        text: formatMessage({ id: 'dbl_chart_axis' }),
      },
      {
        value: SortByEnum.DatasetFieldSort,
        text: formatMessage({ id: 'dbl_chart_dataset_field_sort' }),
      },
    ];
    if (!hiddenOptions?.length) return allOptions;
    return allOptions.filter(item => !hiddenOptions.includes(item.value));
  }, [formatMessage, hiddenOptions]);

  return (
    <Select
      appearance="button"
      listWidth={232}
      matchButtonWidth
      value={value ?? SortByEnum.Default}
      options={options}
      onChange={onChange}
      {...rest}
    />
  );
};

export default SortType;
